// import RulesDetailContainer from '@/containers/rules/RulesDetailContainer';
import RulesListContainer from '@/containers/rules/RulesListContainer';

export default [
  {
    path: '/rules/campaign/:campaignId',
    name: 'RulesList',
    meta: { requiresAuth: true, action: 'view', subject: 'rules' },
    component: RulesListContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/rules.js